<template>
  <form v-on:submit.prevent="submit" class="login-form d-flex flex-column border p-4 p-md-5">
    <div class="login-field">
      <BasicLabel :title="$t('forms.emailAddress')" :required="true" class="fw-bold" />
      <BasicInputText
        :hasRoundedCorners="true"
        class="login-input"
        :placeholder="$t('forms.emailAddress')"
        v-model="email"
      />
      <div v-if="v$.email.$errors.length" class="text-danger">
        <div class="input-errors" v-for="error of v$.email.$errors" :key="error.$uid">
          <div class="error-msg">{{ error.$message }}</div>
        </div>
      </div>

      <div v-else-if="isEmailExists" class="text-danger">
        <div class="error-msg">{{ $t('forms.emailAlreadyExists') }}</div>
      </div>

    </div>
    <ButtonFilled
      class="mt-4 Minicart_button fw-bold text-white"
      :text="$t('common.next')"
      :hasRoundedCorners="true"
    />
  </form>
</template>

<script>
import ButtonFilled from "../../atoms/Button/ButtonFilled.vue";
import BasicInputText from "../../atoms/FormInput/BasicInputText.vue";
import BasicLabel from "../../atoms/FormInput/BasicLabel.vue";
import { userVerificationService, sendVerificationCodeService } from '../../../services/authService';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import { REGISTER_SECTION_TWO } from "../../../constents/app";

export default {
  components: {
    ButtonFilled,
    BasicInputText,
    BasicLabel,
  },
  setup () {
    return { v$: useVuelidate() }
  },
  validations () {
    return {
      email: { required, email }
    }
  },
  data() {
    return {
      email: '',
      isEmailExists: false
    };
  },
  methods: {
    emailVerification(){
      return userVerificationService({"email": this.email});
    },
    sendVerificationCodeService(){
      return sendVerificationCodeService({"email": this.email});
    },
    async submit() {
      this.isEmailExists = false;
      
      this.v$.$touch();
      if (this.v$.$invalid) return;

      let resEmailCheck = await this.emailVerification();
      
      if(resEmailCheck.code == 'JWT_EXPIRED' || resEmailCheck.code == 'JWT_MALFORMED'){
        this.$toast.error("Authentication failed");
        return
      }
      
      if(resEmailCheck.exist){
        this.isEmailExists = true;
        return
      }
      
      let resVerificationEmail = await this.sendVerificationCodeService();

      this.$emit("handle-email", this.email);
      this.$emit("handle-verification-key", resVerificationEmail.key);
      this.$emit("handle-active-section", REGISTER_SECTION_TWO);
    }
  }
};
</script>
<style scoped="scoped">
.customer-checkbox {
  margin-top: 10px;
}
.login-input {
  height: 40px !important;
  padding: 10px 20px !important;
  box-shadow: none !important;
  margin-top: 10px;
}
.form-check {
  padding-left: 27px !important;
}
.login-field,
.login-field-last {
  margin-top: 30px !important;
}

.Minicart_button {
  width: 150px !important;
  height: 40px !important;
}
@media screen and (max-width: 768px) {
  .login-input {
    width: 100% !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .login-input {
    width: 250px !important;
  }
  .form-check-input input {
    width: 15px !important;
  }
}
</style>
